// NOTE :: Where a logged-in user lands, shared by `loginRedirection` (useLoginRequests) and the
// cross-tab reconciler (useAuthTabSync). Kept dependency-free (no stores, no router) so it can run
// anywhere, including the global reconciler mounted in App.vue.

function isInShelterLoginAsContext(user: any): boolean {
  if (!user) return false;
  if (user.admin_name) return true;

  const isAfStaffName = user.full_name === 'AF Staff' || (user.first_name === 'AF' && user.last_name === 'Staff');
  if (!isAfStaffName) return false;

  return user.role === 'admin';
}

function resolveHomeRoute(params: { isSU: boolean; userProfile: any; shelterProfile: any }): string {
  const { isSU, userProfile, shelterProfile } = params;

  const inShelterLoginAsContext = isInShelterLoginAsContext(userProfile);
  if (isSU && !inShelterLoginAsContext) return '/admin/shelters';

  const shelterStillOnboarding = !shelterProfile?.profile;
  if (shelterStillOnboarding) return '/shelter/onboarding';

  return `/shelter${shelterProfile?.home_page || '/animals/in-care'}`;
}

export { isInShelterLoginAsContext, resolveHomeRoute };
